import { all } from 'redux-saga/effects';

import appSaga from './appSaga';

export default function* rootSaga(action) {
	yield all([appSaga(action)]);
}
